var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosesss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4142 3.41422C36.1953 2.63316 36.1953 1.36684 35.4142 0.585781C34.6332 -0.19526 33.3668 -0.19526 32.5858 0.585781L18 15.1716L3.41422 0.585781C2.63316 -0.19526 1.36684 -0.19526 0.585781 0.585781C-0.19526 1.36684 -0.19526 2.63316 0.585781 3.41422L15.1716 18L0.585781 32.5858C-0.19526 33.3668 -0.19526 34.6332 0.585781 35.4142C1.36684 36.1953 2.63316 36.1953 3.41422 35.4142L18 20.8284L32.5858 35.4142C33.3668 36.1953 34.6332 36.1953 35.4142 35.4142C36.1953 34.6332 36.1953 33.3668 35.4142 32.5858L20.8284 18L35.4142 3.41422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosesss);
export default __webpack_public_path__ + "static/media/closesss.ad452425090a41a1cf40037d88da44a2.svg";
export { ForwardRef as ReactComponent };